<template>
  <eagle-form
    :form-key="formKey"
  ></eagle-form>
</template>

<script lang="babel" type="text/babel">
import formMixin from '@/components/form/mixins/formMixin'
import formConfig from './smsFormConfig'
export default {
  mixins: [formMixin],
  data: () => ({
    formKey: 'sms-form',
    meta: {},
  }),
  methods: {
    async beforeFormInit() {
      await Promise.all([])
    },
    validateBeforeSave() {
      // TODO
    },
    async readApi(target) {
      return await this.$api.collection.smsLogApi.read(target)
    },
    async createApi(formData) {
      return await this.$api.collection.smsLogApi.create(formData)
    },
    async updateApi(target, formData) {
      return await this.$api.collection.smsLogApi.update(target, formData)
    },
    async deleteApi(target) {
      return await this.$api.collection.smsLogApi.delete(target)
    },
    getFormConfig() {
      return formConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
